<template>
  <Dialog v-model="visible">
    <div class="mystery-empty-dialog">
      <div class="title">{{ $t('monopoly.mysteryEmptyTitle') }}</div>
      <div class="reward" v-if="reward">
        <div class="icon-wrap">
          <img
            v-if="reward.propId"
            class="icon"
            :src="getPropIcon(reward.propId)"
            :alt="reward.propId"
          >
        </div>
        <div class="name">
          {{ formatPropText(t, reward) }}
        </div>
      </div>
      <div class="empty" v-else>
        {{ $t('monopoly.rewardEmpty') }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../Dialog/index.vue'
import { getPropIcon, formatPropText } from '@/views/act/monopoly/utils/prop'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  rewards: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const reward = computed(() => props.rewards?.[0] || null)
</script>

<style lang="less" scoped>
.mystery-empty-dialog {
  width: 100%;
  text-align: center;
  color: #1a2b5c;
  padding: 10px 8px 20px;
  box-sizing: border-box;
}

.title {
  font-size: 30px;
  font-weight: bold;
  line-height: 1.5;
  margin-bottom: 36px;
}

.reward {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-wrap {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 4px solid #E0FCFE;
  background: #b8e9ff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.icon {
  width: 72%;
  height: 72%;
  object-fit: contain;
}

.name {
  font-size: 28px;
  font-weight: 600;
  line-height: 1.4;
}

.empty {
  font-size: 26px;
  color: rgba(18, 33, 92, 0.6);
  padding: 40px 0;
}
</style>
